import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/ko';

dayjs.extend(relativeTime).locale('ko');

export default dayjs;

export const hoursToSeconds = (hours: number) => hours * 60 * 60;
/**
 * Convert unix timestamp (in miliseconds unit) to locale string
 * @param unixTimestampMs UNIX Timestamp in miliseconds unit
 * @returns locale string of date and time
 */

export const unixTimestampMsToLocaleString = (unixTimestampMs: number | string) => {
  return new Date(+unixTimestampMs).toLocaleString();
};
